module.exports = __webpack_public_path__ + "media/images/list_practice/3-01-b724186ff6e35d7893d5b162dd95d19d.svg";